import clsx from "clsx"
import { type HTMLAttributes, useEffect, useState } from "react"
import type { usePagination } from "@/shared/hooks"
import type { IResponse } from "@/shared/types/index.ts"
import { PageSelect, PerPageSelect } from "../../index.ts"

type IDivProps = HTMLAttributes<HTMLDivElement>
type IPaginationProps = ReturnType<typeof usePagination>

interface IProps<T> extends IPaginationProps, IDivProps {
  response?: IResponse<T>
}

const PaginationNew = <T,>({ setPager, pager, response, className }: IProps<T>) => {
  const [currentPage, setCurrentPage] = useState(pager.page)
  const [perPage, setPerPage] = useState(pager.page_size)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    if (response === undefined) return
    const { current_page = 1, per_page = 30, total = 0 } = response || {}
    setCurrentPage(current_page)
    setPerPage(per_page)
    setTotal(total)
    setPager({ page: current_page, page_size: per_page })
  }, [response])

  if (response && response?.last_page <= 1) {
    return null
  }

  return (
    <div className={clsx("flex w-full justify-between border-border border-t border-l bg-paper px-4 py-3", className)}>
      <PerPageSelect
        onPerPageChange={perPage => {
          setPager({ page: 1, page_size: perPage })
          setPerPage(perPage)
        }}
        perPage={perPage}
        total={total}
      />
      <PageSelect
        currentPage={currentPage}
        onPageChange={page => {
          setPager({ page, page_size: perPage })
          setCurrentPage(page)
        }}
        totalPages={Math.ceil(total / perPage)}
      />
    </div>
  )
}

export default PaginationNew
